import BairesDevHeader from './BairesDevHeader';

export default BairesDevHeader;
